import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { isBeta } from "../../shared/services";

declare var $: any;

import Player from "@vimeo/player/dist/player.js";
import { StoreHelper } from "../../shared/helpers/store.helper";
import { ControllerService } from "../../shared/services/controller.service";

@Component({
    selector: "app-candidate-story",
    templateUrl: "./candidate-story.component.html",
    styleUrls: ["./candidate-story.component.scss"],
    standalone: false
})
export class CandidateStoryComponent implements OnInit {
  items: any = [];
  current: number = 0;
  duration: number = 0;
  progressValue: number = 0;
  underPlay: boolean = false;
  endOfLastVideo: boolean = false;
  OnCaption: boolean = false;

  lastEvent: any;
  player: any;
  videoId: any;
  firstLoad: Boolean = false;
  goToReflection = 0;
  lastUpdated: number = 0;
  courseProgress: number = 0;
  updateInterval: number = 1000;
  isBeta: boolean =  isBeta()
  introText: string = '';
  introHeader: string = ''

  activeNext: boolean = false
  skipToEnd: boolean = false

  constructor(private router: Router, private route: ActivatedRoute, public controller: ControllerService) {}

  ngOnInit() {

    this.skipToEnd = StoreHelper.getObject('fastForward')



    $("body").removeClass();

    $('#video-with-controls').on('fullscreenchange', function(){
      if( (window.document as any).fullscreenElement === null ){
        $("#vimeo_" + this.videoId).attr("height", "300px");
        this.underPlay = false;
        this.player.pause();
      }
    }.bind(this))

    this.introText = this.controller.getSectionProperties().introText
    this.introHeader = this.controller.getSectionProperties().introHeader


    this.items = this.controller.getSectionComponents().map( (component) => {
      return component.properties.vimeoId
    })


    this.loadNewVideo(true)

  }

  onMediaTimeUpdate(data: { seconds: any; percent: any; duration: any }) {
    this.current = data.seconds;
    this.duration = data.duration;
    this.progressValue = data.percent * 100;
    if (this.progressValue > 0) {
      $(".play-next-wrapper").addClass("hide");
      $("body").removeClass("loading");
    }
  }

  onClickProgress(e){
    const target = e.target
    const x = e.pageX - target.offsetLeft, clickedValue = x / target.clientWidth;

    if( clickedValue < target.clientWidth ){

      const newTime = Math.floor( clickedValue * this.current ) - 2
      this.player.setCurrentTime( newTime )
      this.onMediaTimeUpdate( {seconds: newTime, duration : this.duration, percent: newTime/ this.duration })

    }
  }


  onMediaEnd() {
    $("#vimeo_" + this.videoId).attr("height", "300px");
    if (this.items.length == 0) {
      this.underPlay = false;
      this.endOfLastVideo = true;
      this.activeNext = true
      window.document.exitFullscreen()
    }
    this.loadNewVideo(false);
    $('.main-link').show()
    this.controller.next()

  }

  onPlay() {
    $("#vimeo_" + this.videoId).attr("height", "100%");
    $(".play-next-wrapper").addClass("hide");
    if (this.firstLoad) {
      $("body").addClass("loading");
    }
    this.underPlay = true;
    this.player.play();
    this.videobgEnlarge();
    setTimeout(this.videobgEnlarge, 10);
    $('.main-link').hide()

    $("#video-with-controls")[0].requestFullscreen()


    this.player.getDuration()
    .then( (duration) => {
        if( this.skipToEnd ){
          this.duration = duration
          this.player.setCurrentTime( duration - 5 )
        }
        if( !this.OnCaption ){
          this.OffSubtitles()
        }
        if( this.OnCaption ){
          this.OnSubtitles()
        }

    })

  }

  OnSubtitles() {
    this.player.enableTextTrack('en');
    this.OnCaption = true;

  }

  OffSubtitles() {
    this.player.disableTextTrack();
    this.OnCaption = false;
  }

  onBackward() {
    if (this.underPlay && this.current - 5 > 0) {
      this.current -= 5;
      this.player.setCurrentTime(this.current);
    }
  }
  onForward() {

    if (this.underPlay && (this.current + 5) < this.duration) {
      this.current += 5;
      this.player.setCurrentTime(this.duration-3);
    }
  }


  onPause() {
    $("#vimeo_" + this.videoId).attr("height", "300px");
    this.underPlay = false;
    this.player.pause();
    window.document.exitFullscreen()

  }

  onGoToComplateModule() {
    this.controller.next()
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    let timeoutId;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(this.videobgEnlarge, 10);
  }

  videobgEnlarge() {
    let $videoBgAspect = $(".fullScreen .videobg-aspect");
    let $videoBgWidth = $(".fullScreen .videobg-width");
    let $controlContainer = $(".fullScreen .videobg-width .controls-container");
    let videoAspect =
      $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();
    let windowAspect = $(window).height() / $(window).width();
    let calculated = 100 * (videoAspect - (windowAspect - 0.06));
    $controlContainer.css("bottom", Math.max(calculated, 10) + "%");
    if (windowAspect > videoAspect) {
      let calcuationWith = (windowAspect / videoAspect) * 100;
      $videoBgWidth.width(calcuationWith + "%");
      if (calcuationWith > 100) {
        let leftPosition = calcuationWith - 100;
        let controlContainerWidth = 100 - leftPosition;
        $controlContainer.css("width", controlContainerWidth + "%");
        $controlContainer.css("left", leftPosition / 2 + "%");
      }
    } else {
      if (this.underPlay) {
        $videoBgWidth.width(100 + "%");
      }
      // $controlContainer.css('width', 100 + '%');
      // $controlContainer.css('left', 0);
    }
  }


  @HostListener('document:mousemove', ['$event'])
  onMouseMove($event) {
    if (this.underPlay) {
      this.lastEvent = new Date().getTime();
      this.fadeInControls();
    }
  }

  fadeOutControls() {
    if (parseInt($(".controls-container").css("opacity")) !== 0) {
      $(".controls-container").css("opacity", 0);
    }
  }

  fadeInControls() {
    if (parseInt($(".controls-container").css("opacity")) !== 1) {
      $(".controls-container").css("opacity", 1);
    }
  }



  private loadNewVideo(firstLoad = false) {
    this.firstLoad = firstLoad;

    this.lastEvent = new Date().getTime();
    if (this.items.length) {
      $("body").addClass("loading");
      let videoVimeoId = this.items.pop();
      this.videoId = videoVimeoId;
      let content = $(
        '<iframe id="vimeo_' +
          videoVimeoId +
          '" src="https://player.vimeo.com/video/' +
          videoVimeoId +
          '?api=1&mute=0&loop=0&autoplay=0&controls=0" style="visibility:hidden;" onload="this.style.visibility = \'visible\';" width="100%" height="300px;" frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" allowTransparency="true"  allow="autoplay"></iframe>'
      );
      $(".videobg-hide-controls").html(content);

      this.player = null

      this.player = new Player($("#vimeo_" + videoVimeoId));
      this.player.setVolume(1);

      this.current = 0


      this.player.off("timeupdate")
      this.player.off("loaded")
      this.player.off("ended")

      this.player.on("timeupdate", (data) => {


        if (this.lastEvent && this.lastEvent < new Date().getTime() - 5000) {
          this.lastEvent = new Date().getTime();
          this.fadeOutControls();
        }
        if (!this.lastUpdated || this.lastUpdated + this.updateInterval < Date.now()) {
          this.lastUpdated = Date.now()
          data.duration = this.duration;
          this.onMediaTimeUpdate(data);
        }
      });

      this.player.on("loaded", (data) => {
        this.player
          .getDuration()
          .then( (duration) => {
            this.duration = duration
            this.onMediaTimeUpdate({
              seconds: 0,
              percent: 0,
              duration: duration
            });
            if (firstLoad) {
              $("body").removeClass("loading");
            } else {
              // remove loading
              $("body").removeClass("loading");
              // show play button
              $(".play-next-wrapper").removeClass("hide");
            }
          })
          .catch((error) => {
            // an error occurred
          });
      });
      this.player.on("ended", (data) => {
        this.current = this.duration;
        this.onMediaEnd();
      });

      if (!firstLoad) {
        this.onPlay();
      }
    } else {
      // StoreHelper.removeObject("ec_video_urls");
    }
  }
}
